/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class VisibilitySettingsService {
    private title = 'VisibilitySettingsService';

    applyVisibilityThisPageOnly = true;
}
